export function pushcartProduct(state) {
  return state.pushcartProduct;
}
